import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { common } from "..";
import PropTypes from "prop-types";
import numeral from "numeral";
import { vatSettlementListConversion } from "./conversions";

const ReportVatSettlementSheet = ({ goToDetails, setDataReport, detailOnLoad, paramsFromUrl, setCsvData }) => {
  const report = useSelector(state => state.reports.search.report);
  const reportSearch = useSelector(state => state.reports.search);
  const additionalData = reportSearch?.additionalData;

  const vatSettlementDetails = vatSettlementListConversion(report, reportSearch);

  // set data we need to download
  useEffect(() => {
    setDataReport(vatSettlementListConversion(report, reportSearch));
  }, [report]);

  useEffect(() => {
    setCsvData(vatSettlementDetails && vatSettlementDetails.rows ? vatSettlementDetails.rows : []);
  }, [additionalData]);

  const renderTotals = () => {
    return (
      <div className="report-vatSettlement-totals-container">
        <div className="report-vatSettlement-totals-title">Riepilogo</div>
        <div className="report-vatSettlement-totals-cols">
          <div className="report-vatSettlement-totals-col">
            <div className="report-vatSettlement-totals-item">
              <div>IVA su vendite</div>
              <div>
                {numeral(additionalData?.["workspaceSettlement"]?.data?.saleVatAmount).format("0,0.0")}{" "}
                €
              </div>
            </div>
            <div className="report-vatSettlement-totals-item">
              <div>IVA detraibile reg. spec.agr.</div>
              <div>
                {numeral(additionalData?.["workspaceSettlement"]?.data
                  ?.compensationVatAmount).format("0,0.0")}{" "}
                €
              </div>
            </div>
          </div>
          <div className="report-vatSettlement-totals-col">
            <div className="report-vatSettlement-totals-item">
              <div>IVA su acquisti</div>
              <div>
                {numeral(additionalData?.["workspaceSettlement"]?.data
                  ?.purchaseVatAmount).format("0,0.0")}{" "}
                €
              </div>
            </div>
            <div className="report-vatSettlement-totals-item">
              <div>Imposta a debito</div>
              <div>
                {numeral(additionalData?.["workspaceSettlement"]?.data?.debitAmount).format("0,0.0")}{" "}
                €
              </div>
            </div>
          </div>
          <div className="report-vatSettlement-totals-col">
            <div className="report-vatSettlement-totals-item">
              <div>Imposta a credito</div>
              <div>
                {numeral(additionalData?.["workspaceSettlement"]?.data?.creditAmount).format("0,0.0")}{" "}
                €
              </div>
            </div>
            <div className="report-vatSettlement-totals-item">
              <div>Imposta da versare</div>
              <div>
                {numeral(additionalData?.["workspaceSettlement"]?.data?.paymentAmount).format("0,0.0")}{" "}
                €
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="report-vatSettlement-root">
      {renderTotals()}
      <common.ReportCommonTable
        className={"vatSettlementListCustom"}
        report={vatSettlementDetails}
        goToDetails={goToDetails}
      />
    </div>
  );
};

ReportVatSettlementSheet.propTypes = {
  setDetailsPage: PropTypes.func.isRequired,
  setDataReport: PropTypes.func.isRequired
};

export default ReportVatSettlementSheet;
